import datos from "src/services/datos";
import Swal from "sweetalert2";
import esArray from "src/general_components/functionEsArray";
const genero = new datos("genero");

export const getGenero= async (auth) => {
  genero.addCondition("genero", "id", 0, ">");
  const response = await genero.get();
  return esArray(response.wsResponse.genero);
};

export const getGeneroPaginated = async (limit, offset) => {
  genero.addCondition("genero", "id", 0, ">");
  genero.addLimitCondition(limit, offset);
  const response = await genero.get();
  /* devuelvo un objeto de respuesta generica  CON ELEMENTO DE "TOTAL_RECORDS" PARA USARSE CON PAGINACION*/

  let result = {};
  if (!response.wsResponse.empty) {
    result = {
      data: esArray(response.wsResponse.genero),
      total_records: response.wsResponse.total_records,
    };
    return result;
  }
};

export const deleteGenero = async (id) => {
  let status = false;
  await Swal.fire({
    title: "Esta seguro de que desea eliminar este Genero?",
    text: "Si sigue adelante, no se podran revertir los cambios!",
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#3085d6",
    cancelButtonColor: "#d33",
    confirmButtonText: "Si, quiero eliminarlo!",
    cancelButtonText: "No, no estoy seguro!",
  }).then(async (result) => {
    if (result.isConfirmed) {
      const genero = new datos("genero");
      let data = {
        id: id,
      };
      const response = await genero.delete(data);

      if (response.status === "true") {
        status = true;
        await Swal.fire(
          "Eliminado!",
          "El Genero ha sido eliminado exitosamente",
          "success"
        );
      } else {
        await Swal.fire({
          icon: "error",
          title: "Oops...",
          text: response.message,
        });
      }
    }
  });
  return status;
};